import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";

import { YmkSdkShadeFinderConfiguration } from "@hermes/api-model-shade-finder";
import { Settings } from "@hermes/app-core";
import { Logger } from "@hermes/logger";
import { HTTP_JSON_CONTENT_TYPE_HEADER } from "@hermes/utils-generic/constants";
import { LOGGER } from "@hermes/web-logger";

@Injectable()
export class ShadeFinderService {
    constructor(
        private settings: Settings,
        private http: HttpClient,
        @Inject(LOGGER) private logger: Logger,
    ) {}

    public getShadeFinderConfiguration(): Observable<YmkSdkShadeFinderConfiguration> {
        return this.http
            .get<YmkSdkShadeFinderConfiguration>(
                `${this.settings.apiUrl}/shade-finder/configuration`,
                {
                    headers: new HttpHeaders({
                        ...HTTP_JSON_CONTENT_TYPE_HEADER,
                    }),
                },
            )
            .pipe(
                catchError((error) => {
                    this.logger.error(
                        "Error during call of ShadeFinder configuration",
                        error,
                    );
                    return [];
                }),
            );
    }
}
